import { useState } from 'react';
import { CportalService } from 'vopay';
import { Toggle } from 'UI';

type ServiceToggleProps = {
  service: CportalService;
  label: string;
  checked: boolean;
  readOnly: boolean;
  onToggle: (service: CportalService, enabled: boolean) => Promise<void>;
};

export default function ServiceToggle({ service, label, checked, readOnly, onToggle }: ServiceToggleProps) {
  const [isToggling, setIsToggling] = useState(false);

  async function handleChange(enabled: boolean) {
    try {
      setIsToggling(true);
      await onToggle(service, enabled);
    } finally {
      setIsToggling(false);
    }
  }

  return (
    <Toggle
      name={`enable-${service}`}
      checked={checked}
      readOnly={readOnly || isToggling}
      onChange={(e) => handleChange(e.target.checked)}
      label={label}
    />
  );
}
